import React from 'react';
import LearningCenter from '@/components/LearningCenter/LearningCenter';
import TasklistJsonPageHeader from '@/components/TasklistJsonPageHeader/TasklistJsonPageHeader';
import { useLearningCenterHub } from '@/hooks/useLearningCenterHub/useLearningCenterHub';
import { useOverviewContext } from '@/context/OverviewContext';
import { isTeacherPreview } from '@/utils/toolSettingsUtils';

const LearningCenterPage = () => {
  const { userRoleVal } = useOverviewContext();
  const teacherPreview = isTeacherPreview(userRoleVal);
  const { hubConfig, tasksForLearningCenter, isLoading } = useLearningCenterHub();

  return (
    <div className="setup-your-accounts tasklist-json-page tasklist-json-page--tasklist learning-center-page">
      <TasklistJsonPageHeader
        variant="tasklist"
        learningCenterHubLanding
        title="Learning Center"
        description={hubConfig.heroDescription}
      />
      <div className="tasklist-json-body">
        <div className="tasklist-json-post-layout learning-center-page__content">
          <LearningCenter
            variant="hub"
            tasks={tasksForLearningCenter}
            isLoading={isLoading}
            progressLabels={hubConfig.progressLabels}
            countFormatTemplate={hubConfig.countFormat}
            seeMoreLabel={hubConfig.seeMoreLabel}
            seeLessLabel={hubConfig.seeLessLabel}
            emptyStateMessage={hubConfig.emptyStateMessage}
            showSeeMoreOnDescriptions
            showProgressBar={!teacherPreview}
          />
        </div>
      </div>
    </div>
  );
};

export default LearningCenterPage;
